import React from 'react';
import { Lock, Users, ShieldCheck, Key } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function SeguridadHub() {
    const items = [
        {
            title: 'Gestión de Usuarios',
            description: 'Administración de cuentas de operadores y estados.',
            icon: Users,
            href: '/seguridad/usuarios',
            color: 'bg-green-600'
        },
        {
            title: 'Roles de Sistema',
            description: 'Definición de perfiles de acceso y vinculación de roles.',
            icon: ShieldCheck,
            href: '/seguridad/roles',
            color: 'bg-indigo-600'
        },
        {
            title: 'Gestión de Permisos',
            description: 'Administración de claves de acceso y agrupación por módulos.',
            icon: Lock,
            href: '/seguridad/permisos',
            color: 'bg-blue-600'
        },
        {
            title: 'Auditoría de Accesos',
            description: 'Registro de ingresos y operaciones críticas.',
            icon: Lock,
            href: '/seguridad/auditoria',
            color: 'bg-slate-600',
            disabled: true
        },
    ];

    return (
        <div className="p-6 max-w-7xl mx-auto">
            <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
                <div className="px-6 py-8 flex items-center space-x-6 bg-slate-800 text-white">
                    <div className="p-4 bg-white/10 rounded-2xl backdrop-blur-sm">
                        <ShieldCheck className="w-10 h-10 text-blue-400" />
                    </div>
                    <div>
                        <h3 className="text-2xl font-black tracking-tight uppercase">Módulo de Seguridad (RBAC)</h3>
                        <p className="text-blue-200 text-sm font-medium italic">Control de acceso institucional y administración de operadores.</p>
                    </div>
                </div>

                <div className="p-8 bg-gray-50/50">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {items.map((item, idx) => (
                            <Link
                                key={idx}
                                to={item.disabled ? '#' : item.href}
                                className={`bg-white p-6 rounded-2xl shadow-sm border border-gray-200 flex flex-col items-center text-center group transition-all duration-300 ${item.disabled
                                    ? 'opacity-60 cursor-not-allowed'
                                    : 'hover:shadow-xl hover:-translate-y-1 hover:border-blue-300'
                                    }`}
                            >
                                <div className={`p-4 rounded-2xl ${item.color} bg-opacity-10 mb-4 group-hover:scale-110 transition-transform duration-500`}>
                                    <item.icon className={`w-8 h-8 ${item.color.replace('bg-', 'text-')}`} />
                                </div>
                                <h4 className="font-bold text-lg text-gray-800 group-hover:text-blue-600 transition-colors uppercase tracking-tight">{item.title}</h4>
                                <p className="text-xs text-gray-500 mt-2 leading-relaxed">
                                    {item.description}
                                </p>
                                {item.disabled && (
                                    <span className="mt-4 px-2 py-0.5 bg-gray-100 text-gray-400 text-[0.6rem] font-black uppercase rounded tracking-widest">
                                        Próximamente
                                    </span>
                                )}
                            </Link>
                        ))}
                    </div>
                </div>

                <div className="px-6 py-4 bg-white border-t border-gray-100 flex items-center gap-2">
                    <Key className="w-4 h-4 text-slate-400" />
                    <span className="text-[0.7rem] text-slate-500 font-bold uppercase tracking-widest italic">
                        El sistema utiliza encriptación BCrypt para todas las credenciales institucionales.
                    </span>
                </div>
            </div>
        </div>
    );
}
